class status {
  constructor(
    present,
    missing,
    inconsistencies,
    hoursFalls,
    lates,
    retreats,
    licensesDays,
    licensesHours,
    extras
  ) {
    this.Presentes = present == 0 ? 2 : present;
    this.Ausentes = missing;
    this.Inconsistencias = inconsistencies;
    this.HorasCaidas = hoursFalls;
    this.Tardes = lates;
    this.Retiros = retreats;
    this.LicenciasDias = licensesDays;
    this.LicenciasHoras = licensesHours;
    this.extras = extras;
  }
  static fromJson({
    presentes,
    ausentes,
    inconsistencias,
    horasCaidas,
    tardes,
    retiros,
    licenciasDias,
    licenciasHoras,
    extras,
  }) {
    return new status(
      presentes,
      ausentes,
      inconsistencias,
      horasCaidas,
      tardes,
      retiros,
      licenciasDias,
      licenciasHoras,
      extras
    );
  }
}
export default status;
